import React, { useState } from 'react'
import {
  Container,
  Header,
  Content,
  ErrorMessage,
  SuccessMessage,
} from './CoachingEventManagement.styled'
import { CoachingEventCreation } from './CoachingEventCreation'
import { Ribbon } from '../_common/Ribbon'

// Timeout for feedback messages
const FEEDBACK_TIMEOUT = 10000

export const CoachingEventManagement: React.FC = () => {
  const [success, setSuccess] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const popError = (message: string) => {
    setError(message)
    setTimeout(() => setError(null), FEEDBACK_TIMEOUT)
  }

  const popSuccess = (message: string) => {
    setSuccess(message)
    setTimeout(() => setSuccess(null), FEEDBACK_TIMEOUT)
  }

  return (
    <Container>
      <Ribbon />
      <Header>Coaching Event Management</Header>
      <Content>
        <CoachingEventCreation popError={popError} popSuccess={popSuccess} />
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {success && <SuccessMessage>{success}</SuccessMessage>}
      </Content>
    </Container>
  )
}
